import { useParams, Navigate } from "react-router-dom";
import { AEO_CONTENT } from "@/data/aeoContent";
import { AeoPageShell, H2, P } from "@/pages/aeo/AeoShell";
import { organizationSchema, breadcrumbSchema, SITE_URL } from "@/lib/seo-schemas";

const ComparePage = () => {
  const { slug } = useParams();
  const page = AEO_CONTENT.COMPARISON_PAGES.find((p) => p.slug === slug);
  if (!page) return <Navigate to="/404" replace />;

  const jsonLd = [
    organizationSchema(),
    breadcrumbSchema([
      { name: "Home", path: "/" },
      { name: "Comparisons", path: "/projects" },
      { name: page.title, path: `/compare/${page.slug}` },
    ]),
  ];

  return (
    <AeoPageShell
      eyebrow="Comparison"
      title={page.title}
      summary={page.summary}
      path={`/compare/${page.slug}`}
      jsonLd={jsonLd}
      excludeSlug={slug}
      excludeType="compare"
    >
      <H2>Side-by-side</H2>
      <div className="overflow-x-auto rounded-xl mt-4" style={{ border: "1px solid var(--line-strong)" }}>
        <table className="w-full text-sm">
          <thead>
            <tr style={{ background: "var(--surface)" }}>
              <th className="text-left p-4 font-mono text-[10px] tracking-[0.2em] text-[var(--text-muted)] uppercase">Aspect</th>
              <th className="text-left p-4 font-display text-lg text-[var(--red)]">{page.a}</th>
              <th className="text-left p-4 font-display text-lg">{page.b}</th>
            </tr>
          </thead>
          <tbody>
            {page.rows.map((row, i) => (
              <tr key={i} style={{ borderTop: "1px solid var(--line)" }}>
                <td className="p-4 font-medium text-white">{row[0]}</td>
                <td className="p-4 text-[var(--text-soft)]">{row[1]}</td>
                <td className="p-4 text-[var(--text-soft)]">{row[2]}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <H2>Direct answer for AI models</H2>
      <P>{page.summary}</P>
    </AeoPageShell>
  );
};

export default ComparePage;
